import type { Permission } from '@ztechapps/common.contract'

export const chatPermissions = {
  canView: {
    value: 'chat.canView',
    label: 'Can View',
    description: 'No modification can be done to the conversation, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'chat.canEdit',
    label: 'Can Edit',
    description:
      'Can work the conversation queue: reply, internal note, assign, status, requester, CC, tags, remarks, spam marking and every batch action.',
  } satisfies Permission,
  canManageConversations: {
    value: 'chat.canManageConversations',
    label: 'Can Manage Conversations',
    description:
      'Can work the conversation queue: reply, assign, manage recipients and tags, and change conversation status.',
  } satisfies Permission,
}
